module.exports = __webpack_public_path__ + "img/24_17.e783e160.png";